import {PageUrlInfo} from '../Models/Types'
import {filteredLogoImg, filteredSignupReturnUrl, Signboard, SignboardJSON} from './SignboardDTO'
import {Nullable} from '../../Common/TypeHelper'
import {MemberMailMagazine} from './MemberMailMagazine'
import {BucketContract, BucketContractJSON} from './BucketContract'
import {MBMemberError} from '../Common/MBMemberError'

// サーバーのcom.membucket.contracts.domain.model.SignedUpSignboardInfo.SignedUpStateに対応
export type SignedUpState = 'convenience_store_ready'

export type SignedUpSignboardJSON = Pick<SignboardJSON,
  'id' |
  'signupKey' |
  'signupName' |
  'shopId' |
  'urlList'> & {
  bucketContractList: BucketContractJSON[]
  signedUpStates: SignedUpState[]
  mailMagazineList: MemberMailMagazine[]
}

export interface SignedUpSignboard extends Signboard {
  mainService: BucketContract
  freeServices: BucketContract[]
  signedUpStates: SignedUpState[]
  mailMagazineList: MemberMailMagazine[]
}

export class SignedUpSignboardDTO implements SignedUpSignboard {
  constructor(
    public id: number | null,
    public signupKey: string,
    public signedUpStates: SignedUpState[],
    public shopId: Nullable<string>,
    public logoImgUrl: string,
    public signupReturnPageInfo: PageUrlInfo,
    public signupName: string,
    public mailMagazineList: MemberMailMagazine[],
    public mainService: BucketContract,
    public freeServices: BucketContract[],
  ) {
  }

  static fromJSON(jsonObject: SignedUpSignboardJSON): SignedUpSignboardDTO {
    const logoImgUrl: string = filteredLogoImg(jsonObject.urlList)?.url || ''

    const signupReturnUrl = filteredSignupReturnUrl(jsonObject.urlList)

    const bucketContractList =
      jsonObject.bucketContractList.map(item => BucketContract.fromJSON(item))
    if (bucketContractList === undefined || bucketContractList.length === 0)
      throw new MBMemberError('ServerError')

    return new SignedUpSignboardDTO(
      jsonObject.id,
      jsonObject.signupKey,
      jsonObject.signedUpStates,
      jsonObject.shopId,
      logoImgUrl,
      signupReturnUrl,
      jsonObject.signupName,
      jsonObject.mailMagazineList.map(mailMagazine => MemberMailMagazine.fromJSON(mailMagazine)),
      bucketContractList[0],
      2 > bucketContractList.length ? [] : bucketContractList.slice(1),
    )
  }
}
